import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as Styles from './Montage.Styles';
import Button from '../Button/Button';
import Container from '../Container/Container';
import ContainerBG from '../ContainerBG/ContainerBG';

const Montage = () => {
  // const [play, setPlay] = useState(false);
  // const elRef = useRef(null);

  // const changePlay = () => {
  //   if (
  //     elRef.current.offsetTop - elRef.current.offsetHeight / 2 <
  //     window.scrollY
  //   ) {
  //     setPlay(true);
  //   } else {
  //     setPlay(false);
  //   }
  // };

  // useEffect(() => {
  //   const watchScroll = () => {
  //     window.addEventListener('scroll', changePlay);
  //   };
  //   watchScroll();

  //   return () => {
  //     window.removeEventListener('scroll', changePlay);
  //   };
  // }, []);

  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "assembly-background_wm_enlarge_karabane-75162858b" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, quality: 80)
        }
      }
    }
  `);

  return (
    <ContainerBG
      image={data.file.childImageSharp.gatsbyImageData}
      objectPostion={'bottom center'}>
      <Container flex fluid height='100vh' padding='0 16px'>
        <Styles.Content>
          <span className='head'>Nastąpił</span>
          <span className='cnt'>CZAS MONTAŻU.</span>
          <span className='head'>To bardzo ważny etap!</span>
          <span className='cnt last'>Chętnie pomożemy</span>
          <Button link='/montaz' rounded='true' color='#fff' arrow='true'>
            Więcej
          </Button>
        </Styles.Content>
      </Container>
    </ContainerBG>
    // <Styles.Section ref={elRef}>
    //   <Styles.MontageContainer
    //     height='100vh'
    //     bgImage={data.file.childImageSharp.fluid.srcSet}
    //     flex>
    //     <Styles.WallpaperPart
    //       className='part1'
    //       animPlay={play}></Styles.WallpaperPart>
    //     <Styles.WallpaperPart
    //       className='part2'
    //       animPlay={play}></Styles.WallpaperPart>
    //     <Styles.WallpaperPart
    //       className='part3'
    //       animPlay={play}></Styles.WallpaperPart>
    //     <Styles.WallpaperPart
    //       className='part4'
    //       animPlay={play}></Styles.WallpaperPart>
    //     <Styles.WallpaperPart
    //       className='part5'
    //       animPlay={play}></Styles.WallpaperPart>
    //     <Styles.Content animPlay={play}>
    //       <span className='head'>Nastąpił</span>
    //       <span className='cnt'>CZAS MONTAŻU.</span>
    //       <span className='head'>To bardzo ważny etap!</span>
    //       <span className='cnt last'>Chętnie pomożemy</span>
    //       <Button link='/montaz' rounded='true' color='#fff' arrow>
    //         Więcej
    //       </Button>
    //     </Styles.Content>
    //   </Styles.MontageContainer>
    // </Styles.Section>
  );
};

export default Montage;
